import instance from "..";
import { dummyDashboard } from "src/constants/dummyDashboard";
import { setDashboardData } from "src/reducers/dashboard";

export const getDashboardDataAction: any =
  () => async (dispatch: any) => {
    try {
      const res = await instance.get(`/api/v1/admin/dashboard`);

      const apiResponse = res?.data;

      if (!apiResponse?.success || !apiResponse?.data) {
        dispatch(setDashboardData(dummyDashboard));
        return dummyDashboard;
      }

      const raw = apiResponse.data;

      const formatted = {
        result: {
          schools:
            raw.schools?.data?.map((s: any) => ({
              id: s.id,
              name: s.name,
              address: s.address,
              pincode: s.pincode,
              landmark: s.landmark,
              phone: s.phone,
              email: s.email,
              createdOn: s.createdAt,
            })) || [],

          cameras:
            raw.cameras?.data?.map((c: any) => ({
              id: c.id,
              number: c.cameraNumber,
              key: c.cameraKey,
              sim: c.simNumber,
              driver: c.driverName,
              status: c.status === "Active",
            })) || [],

          parents:
            raw.parents?.data?.map((p: any) => ({
              id: p.id,
              name: p.name,
              email: p.email,
              phone: p.phone,
              childCount: p.childCount,
            })) || [],

          captains:
            raw.captains?.data?.map((c: any) => ({
              id: c.id,
              name: c.name,
              phone: c.phone,
              createdAt: c.createdAt,
            })) || [],

          bookings:
            raw.bookings?.data?.map((b: any) => ({
              id: b.id,
              parent: b.parentName,
              phone: b.phone,
              child: b.childName,
              grade: b.grade,
              emergencyName: b.emergencyContactName,
              emergencyPhone: b.emergencyPhone,
            })) || [],
        },
      };

      dispatch(setDashboardData(formatted));
      return formatted;
    } catch {
      dispatch(setDashboardData(dummyDashboard));
      return dummyDashboard;
    }
  };